import React, { useEffect, useRef, useState } from "react";
import { Container, Grid2 } from "@mui/material";

import { Link, useParams } from "react-router-dom";
import DishCard from "../components/common/DishCard";
import StickyStripe from "../components/common/StickyStripe";
import productService from "../services/productService";
import Breadcrumbs from "../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import DishCardSkeleton from "../components/common/DishCardSkeleton";
import SkeletonMenuItem from "../components/common/SkeletonMenuItem";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";
const DishMaterial = () => {
  const navbarRef = useRef(null);
  // const paramsddd = useParams();
  const { subCategoryURL } = useParams();
  // const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const parts = subCategoryURL?.split("-");
  parts.pop(); // remove last part

  const subCategoryName = parts
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Add " Js" at the end
  const id = subCategoryURL?.split("-").pop();

  const [productDetails, setProductDetails] = useState(null);
  const [selectedSizes, setSelectedSizes] = useState({});
  useEffect(() => {
    if (id) {
      fetchProductDetails(id);
    }
  }, [id]);
  const fetchProductDetails = async (extdId) => {
    try {
      const data = await productService.getProducteDetails(extdId);
      setProductDetails(data);

      const defaultSizes = {};
      data?.forEach((prod) => {
        if (prod.productSizes?.length > 0) {
          defaultSizes[prod.productURL] = prod.productSizes[0].productSizes;
        }
      });

      setSelectedSizes(defaultSizes);
      setError(null);
    } catch (error) {
      setError("Failed to load data.");
    }
  };

  const FinalmenuItems =
    productDetails?.map((item) => ({
      label: item.productName,
      id: item.productURL.replace(/-/g, "_"),
    })) || [];

  return (
    <>
      {error ? (
        <ErrorHandlingDesign errorMessage={error} />
      ) : (
        <>
          <section className="dish-banner inner-baner">
            {/* <img src={bannerimg} alt="" className="banner-right" /> */}
            <Container>
              <div className="breadcrumb">
                <Breadcrumbs />
              </div>
              <div
                className="back-arrow text-white"
                onClick={() => navigate(-1)}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M10.0164 2.86402C10.5046 2.41035 11.2681 2.43834 11.7218 2.92652C12.1754 3.41471 12.1475 4.17823 11.6593 4.63189L5.9091 9.97545C5.56441 10.2958 5.27721 10.5634 5.03763 10.795L21.7309 10.795C22.3974 10.795 22.9376 11.3353 22.9376 12.0017C22.9376 12.6681 22.3974 13.2084 21.7309 13.2084L4.96299 13.2084C5.21692 13.4563 5.52784 13.7462 5.90908 14.1005L11.5886 19.3785C12.0768 19.8322 12.1048 20.5957 11.6511 21.0839C11.1974 21.5721 10.4339 21.6 9.94575 21.1464L4.20777 15.814C3.51539 15.1707 2.90681 14.6052 2.48249 14.0857C2.02422 13.5246 1.65356 12.8684 1.65356 12.0379C1.65357 11.2075 2.02424 10.5513 2.48251 9.99021C2.90682 9.47068 3.51538 8.90523 4.20774 8.26193L10.0164 2.86402Z"
                    fill="#02060C"
                    fillOpacity="0.75"
                  />
                </svg>
              </div>

              <div className="banner-content">
                <h1 className="text-white-highest-emphasis">
                  Explore all packaging <br />
                  options for {subCategoryName}
                </h1>
                <p className="text-dark-high-emphasis">
                  Sold by 8 vendors across India
                </p>
              </div>
            </Container>
          </section>
          <div className="sticky-material-menu">
            <section className="dish-material-menu">
              <Container>
                <Grid2
                  container
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid2 size={12}>
                    <div className="material-card-menu packaging-detail-sticky-menu">
                      <ul className="packaging-info-list packaging-material">
                        {FinalmenuItems.length > 0
                          ? FinalmenuItems.map((item, index) => (
                              <StickyStripe
                                isShowIcon={false}
                                navMenu={item}
                                key={item.id}
                                stickyMenuItems={FinalmenuItems}
                                navbarRef={navbarRef}
                                defaultActiveState={productDetails[0].productURL.replace(
                                  /-/g,
                                  "_"
                                )}
                              />
                            ))
                          : // Render 5 skeleton items as placeholders
                            Array.from({ length: 1 }).map((_, index) => (
                              <SkeletonMenuItem key={index} />
                            ))}
                      </ul>
                    </div>
                    {/* <MaterialCard menuItems={menuItems} /> */}
                  </Grid2>
                </Grid2>
              </Container>
            </section>
            {productDetails ? (
              productDetails.map((product, index) => {
                const productUrlId = product.productURL.replace(/-/g, "_");
                const selectedSize = selectedSizes[product.productURL];

                const sizes = product.productSizes || [];

                const filteredSizeObj = sizes.find(
                  (item) => item.productSizes === selectedSize
                );

                return (
                  <section
                    className="dish-wrapper"
                    id={productUrlId}
                    key={product.productURL || index}
                  >
                    <Container>
                      <div className="section-title">
                        <h2 className="text-center">{product.productName}</h2>
                      </div>

                      {sizes.length > 0 &&
                      sizes.some((s) => s.productSizes !== "NA") ? (
                        <>
                          <div className="nav-items">
                            <ul className="new-ul-nav">
                              {sizes.map((sizeItem, sizeIdx) => (
                                <li key={sizeItem.productSizes}>
                                  <Link
                                    className={
                                      selectedSize === sizeItem.productSizes
                                        ? "active-ul"
                                        : ""
                                    }
                                    onClick={() =>
                                      setSelectedSizes((prev) => ({
                                        ...prev,
                                        [product.productURL]:
                                          sizeItem.productSizes,
                                      }))
                                    }
                                  >
                                    {sizeItem.productSizes}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>

                          {filteredSizeObj ? (
                            <Grid2 container spacing={{ lg: 2, xs: 1 }}>
                              {filteredSizeObj.productList.map(
                                (vendor, vIdx) => (
                                  <Grid2
                                    key={`${product.productURL}-${vendor.vendorName}`}
                                    size={{ lg: 3, md: 4, sm: 4, xs: 6 }}
                                    className="product-card"
                                  >
                                    <DishCard
                                      // productData={vendor}
                                      showBadge={
                                        vendor.vendorName === "Ambica" ||
                                        vendor.vendorName === "Sha Misrimal"
                                          ? false
                                          : true
                                      }
                                      priceList={vendor.priceList}
                                      title={vendor.vendorName}
                                      description={vendor.vendorDesc}
                                      image={vendor.priceList[0].productImage}
                                      link={`enquire-vendors/${product.productURL}-${vendor.vendorId}`}
                                      state={{
                                        productName: product.productName,
                                        vendorName: vendor.vendorName,
                                      }}
                                    />
                                  </Grid2>
                                )
                              )}
                            </Grid2>
                          ) : (
                            <p className="text-center">No variants available</p>
                          )}
                        </>
                      ) : (
                        <Grid2 container spacing={{ lg: 2, xs: 1 }}>
                          {product.productSizes?.[0]?.productList?.length >
                          0 ? (
                            product.productSizes[0].productList.map(
                              (vendor, vIdx) => (
                                <Grid2
                                  key={`vendor-${vendor.vendorId}`}
                                  size={{ lg: 3, md: 4, sm: 4, xs: 6 }}
                                  className="product-card"
                                >
                                  <DishCard
                                    showBadge={
                                      vendor.vendorName === "Ambica" ||
                                      vendor.vendorName === "Sha Misrimal"
                                        ? false
                                        : true
                                    }
                                    productData={vendor}
                                    priceList={vendor.priceList}
                                    title={vendor.vendorName}
                                    description={vendor.vendorDesc}
                                    image={vendor.priceList[0].productImage}
                                    link={`enquire-vendors/${product.productURL}-${vendor.vendorId}`}
                                    state={{ productName: product.productName }}
                                  />
                                </Grid2>
                              )
                            )
                          ) : (
                            <p className="text-center">No items available</p>
                          )}
                        </Grid2>
                      )}
                    </Container>
                  </section>
                );
              })
            ) : (
              <Container>
                <Grid2 container spacing={{ lg: 2, xs: 1 }}>
                  {[...Array(8)].map((_, idx) => (
                    <Grid2
                      key={idx}
                      size={{ lg: 3, md: 4, sm: 6, xs: 6 }}
                      className="product-card"
                    >
                      <DishCardSkeleton />
                    </Grid2>
                  ))}
                </Grid2>
              </Container>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DishMaterial;
